import { Component, OnInit, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { LoadingTriangle } from '@lightwaverf/simple-d3-graph';
@Component({
    selector: 'lds-ng-lw-data-studio',
    template: `
    <div class="lds-full-screen-container" #loading></div>
  `,
    styles: [],
    standalone: false
})
export class NgLwDataStudioComponent implements OnInit, AfterViewInit {
	@ViewChild('loading', {static: false}) loadingArea: ElementRef;
	currentTime: number;
	sub: any;
	featureNum: number;
	tempFeatureNum: number;
	constructor() { }

	ngOnInit() {
	}

	ngAfterViewInit() {
		new LoadingTriangle(this.loadingArea.nativeElement);
	}
}
